import { getMarkRange } from '@tiptap/vue-3';
import { getEditor, isEnabled } from '../composables/editorsMap';
import TooltipOptions from '../menuItemComponents/TooltipOptions.vue';
import { Info } from 'lucide-vue-next';
export const getTooltipOptions = (id: string) => {
  const editor = getEditor(id)?.value;

  return {
    disabled: !isEnabled(id, 'tooltip'),
    icon: Info,
    title: 'הסבר צף',
    type: 'select',
    loseFocus: true,
    component: TooltipOptions,
    props: {},
    action: data_tooltip => {
      if (data_tooltip) {
        const { state } = editor;
        const { empty, $cursor } = state.selection;

        if (!empty) {
          editor.chain().focus().setTooltip({ data_tooltip }).run();
        } else {
          const tr = state.tr;
          const tooltipMarkType = state.schema.marks.tooltip;
          const currentMarks = $cursor.marks();
          const tooltipMark = currentMarks.find(
            mark => mark.type === tooltipMarkType,
          );
          const range = getMarkRange(
            $cursor,
            tooltipMarkType,
            tooltipMark.attrs,
          );
          if (range) {
            const from = range.from;
            const to = range.to;
            tr.addMark(from, to, tooltipMarkType.create({ data_tooltip }));
            editor?.view.dispatch(tr);
          }
        }
      } else {
        editor?.chain().focus().unsetTooltip().run();
      }
    },
    isActive: () => editor?.isActive('tooltip'),
  };
};
